import React from 'react';
import CustomNavbar from '../components/CustomNavbar';
import FooterTwo from '../components/Footer/FooterTwo';
import FooterData from '../components/Footer/FooterData';
import AboutUs from '../components/AboutUs';

const About = () => {
    return(
        <div className="body_wrapper">
            <CustomNavbar cClass="custom_container p0" hbtnClass="new_btn"/>
            <AboutUs/>
            <FooterTwo FooterData={FooterData}/>
        </div>
    )
}
export default About;